import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleMenu } from "../../../common/models/menu";
import { ExercicesProvider } from '../../../exercices/providers/exercices-provider';
import { PhaseProvider } from '../../providers/phase-provider.services';
import { AnnualPlanDialogFormPhaseComponent } from '../../components/dialog-form-phase/annual-plan-dialog-form-phase.component';
import { AnnualPlanDialogFormMacrocycleComponent } from '../../components/dialog-form-macrocycle/annual-plan-dialog-form-macrocycle.component';
import { AnnualPlanService } from '../../providers/annual-plans.services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HasPendingChangesGuard } from '../../../common/guards/has-pending-changes';
import { AnnualPlanDialogFormAttributeComponent } from '../../components/dialog-form-attribute/annual-plan-dialog-form-attribute.component';
import { ArrayUtils } from "../../../common/providers/array-utils";
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { AnnualPlanRights } from '../../providers/annual-plan-rights';
import { CurrentUser } from "../../../common/providers/current-user";
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { ConfigProvider } from "../../../config-provider.service";
import { Title } from '@angular/platform-browser';
import { LibraryService } from '../../../libraries/providers/library.services';
import { Subscription } from 'rxjs';
import { ApiError } from '../../../common/error/api-error';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Organization } from "../../../common/models/organization";
import { AnnualPlan } from "../../../common/models/annual-plan";
import { Library } from "../../../common/models/library";
import { Week } from "../../../common/models/week";
import { Phase } from "../../../common/models/phase";
import { ExerciceCategory } from "../../../common/models/exercice-category";
import { AnnualPlanMacroCycle } from "../../../common/models/annual-plan-macro-cycle";
import { AnnualPlanPhase } from "../../../common/models/annual-plan.phase";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { MainActionComponent } from "../../../common/components/main-action/main-action";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { AnnualPlanGraphComponent } from "../../components/graph/annual-plan-graph.component";
import { AnnualPlanSideMenuWeekEditComponent } from "../../components/site-menu-week-edit/side-menu-week-edit";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { LibrariesSideMenuComponent } from "../../../libraries/components/side-menu/side-menu";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { MatError, MatFormField } from "@angular/material/form-field";
import { NgForOf, NgIf } from "@angular/common";
import { MatMiniFabButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { MatTooltip } from "@angular/material/tooltip";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SecondsToDHMPipe } from "../../../common/pipes/seconds-to-DHM-pipe";
import { AuthorizationChecker } from "../../../common/security/authorization-checker";
import { User } from "../../../common/models/user";

@Component({
  selector: 'app-annual-plan-library-show',
  templateUrl: './annual-plan-library-show.component.html',
  styleUrls: ['./annual-plan-library-show.scss'],
  imports: [
    Error404Component,
    ModuleContentComponent,
    AnnualPlanGraphComponent,
    AnnualPlanSideMenuWeekEditComponent,
    MainActionComponent,
    SideMenuComponent,
    HeaderComponent,
    LibrariesSideMenuComponent,
    Error401Component,
    PageContentComponent,
    MatFormField,
    MatError,
    ReactiveFormsModule,
    NgIf,
    NgForOf,
    MatMiniFabButton,
    MatInput,
    MatTooltip,
    CdkTextareaAutosize,
    FlexLayoutModule,
    TranslateModule,
    SecondsToDHMPipe,
  ],
  standalone: true
})
export class AnnualPlanLibraryShowComponent implements OnInit, OnDestroy {

    get f() {
        return this.annualPlanForm.controls;
    }
    public mainActions: ModuleMenu[] = [];
    public titleSwitcherItems: ModuleMenu[] = [];
    public pageTitle = 'AnnualPlanShow';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public organization: Organization = {} as Organization;
    public library: Library = {} as Library;
    public annualPlan: AnnualPlan = {} as AnnualPlan;

    public weeks: Week[] = [];
    public isEditMode = false;
    public clickedWeek: Week = {} as Week;
    public phases: Phase[] = [];

    public exerciseCategories: ExerciceCategory[] = [];
    public annualPlanMacroCycles: AnnualPlanMacroCycle[] = [];
    public annualPlanMacroCyclesTest: AnnualPlanMacroCycle[] = [];
    public annualPlanMacroCyclesToDelete: number[] = [];
    public annualPlanPhases: AnnualPlanPhase[] = [];
    public annualPlanPhasesToDelete: number[] = [];
    public annualPlanRights: AnnualPlanRights = new AnnualPlanRights(this.utils);

    public isSubmitting = false;
    public annualPlanForm: FormGroup;

    private weeksToUpdate: any = [];
    private phaseDialog: any;
    private macroCycleDialog: any;
    private _displayContext = 0;
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        public dialog: MatDialog,
        public breadcrumbProvider: BreadcrumbProvider,
        public authorizationChecker: AuthorizationChecker,
        private route: ActivatedRoute,
        private exerciseProvider: ExercicesProvider,
        private phaseProvider: PhaseProvider,
        private annualPlanService: AnnualPlanService,
        private router: Router,
        private toaster: MatSnackBar,
        private translater: TranslateService,
        private translator: TranslateService,
        private arrayUtils: ArrayUtils,
        private fb: FormBuilder,
        private changesGuard: HasPendingChangesGuard,
        private _title: Title,
        private utils: UtilsProvider,
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
    ) {
        // authorizationChecker.addVoter(new AnnualPlanVoter());

        // use the FormBuilder to create a form group
        this.annualPlanForm = this.fb.group({
            comment: new FormControl('', [Validators.maxLength(1024)])
        });
    }

    @HostListener('window:beforeunload')
    public doSomething() {
        return !this.changesGuard.hasChanges();
    }

    public ngOnInit() {
        Promise.all([
            this.loadData(),
        ]).then(() => {
            if (!this.annualPlan.hasRight(User.RIGHTS.VIEW)) {
                this.is401 = true;
                return;
            }
            if (this.isEditMode) {
                if (!this.annualPlan.hasRight(User.RIGHTS.EDIT)) {
                    this.is401 = true;
                    return;
                }
            }
            this.createPageTitle();
            this.createBreadcrumb();
            this.isLoading = false;

        }).catch((error: any) => this.onError(error));
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public weekEventClicked(week: Week) {
        this.clickedWeek = week;
    }

    public weeksChanged(weeks: Week[]) {
        this.weeks = weeks;
    }

    /**
     * Create an unique array of Week elements to update
     *
     * @param week
     */
    public weekUpdated(week: Week) {
        this.changesGuard.registerChanges(() => this.onSaveClicked());

        const element = this.weeksToUpdate.find((x:any) => x.id === week.id);
        if (!element) {
            this.weeksToUpdate.push(week);
        } else {
            Object.assign(element, week);
        }
    }

    public onEditClicked(row: AnnualPlan): void {
        const currentPath = this.router.url;
        let url: string | null = null;

        if (currentPath.includes('plans-elitment')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans-elitment/' + row.id + '/edit';
        } else if (currentPath.includes('plans-super-coach')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans-super-coach/' + row.id + '/edit';
        } else if (currentPath.includes('plans/personal')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans/personal/' + row.id + '/edit';
        } else {
            // Default to personal plans
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans/personal/' + row.id + '/edit';
        }
        this.router.navigateByUrl(url);
    }

    public onCancelClicked(row: AnnualPlan): void {
        const currentPath = this.router.url;
        let url: string | null = null;

        if (currentPath.includes('plans-elitment')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans-elitment/' + row.id;
        } else if (currentPath.includes('plans-super-coach')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans-super-coach/' + row.id;
        } else if (currentPath.includes('plans/personal')) {
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans/personal/' + row.id;
        } else {
            // Default to personal plans
            url = '/' + this.organization!.code + '/libraries/' + row.libraryId + '/plans/personal/' + row.id;
        }
        this.router.navigateByUrl(url);
    }

    public onChangeComment() {
        this.changesGuard.registerChanges(() => this.onSaveClicked());
    }

    public onSaveClicked(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isLoading = true;
            this.save()
                .then(() => {
                    this.isLoading = false;
                    this.changesGuard.unregisterChanges();
                    this.toaster.open(this.translator.instant('AnnualPlan_Saved'), '', {duration: 5000});
                    resolve(true);
                })
                .catch((error: any) => {
                    this.onError(error);
                    resolve(false);
                });
        });
    }

    public save(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const savePlan = new Promise((res, rej) => {
                Object.assign(this.annualPlan, this.annualPlanForm.value, {organization: this.organization});

                this.subscriptions.push(
                    this.annualPlanService.edit(this.annualPlan).subscribe((plan) => {
                        res(plan);
                    }
                    )
                );
            });

            const saveWeeks = new Promise((res, rej) => {
                this.subscriptions.push(
                    this.annualPlanService.saveWeeks(this.organization, this.annualPlan, this.weeksToUpdate).subscribe(() => {
                        res(null);
                    })
                );
            });

            const saveMacroCycles = new Promise((res, rej) => {
                this.subscriptions.push(
                    this.annualPlanService.saveMacroCycles(this.organization, this.annualPlan, this.annualPlanMacroCycles, true).subscribe(() => {
                        res(null);
                    })
                );
            });

            const savePhases = new Promise((res, rej) => {
                this.subscriptions.push(
                    this.annualPlanService.savePhases(this.organization, this.annualPlan, this.annualPlanPhases).subscribe(() => {
                        res(null);
                    })
                );
            });

            const deletePhases = new Promise((res, rej) => {
                this.annualPlanPhasesToDelete.map((phaseId) => {
                    this.subscriptions.push(
                        this.annualPlanService.deletePhases(this.organization, this.annualPlan, phaseId).subscribe()
                    );
                });

                res(null);
            });

            const deleteMacroCycles = new Promise((res, rej) => {
                this.annualPlanMacroCyclesToDelete.map((macroCycleId) => {
                    this.subscriptions.push(
                        this.annualPlanService.deleteMacroCycles(this.organization, this.annualPlan, macroCycleId).subscribe()
                    );
                });

                res(null);
            });

            Promise.all([savePlan, saveWeeks, saveMacroCycles, savePhases, deletePhases, deleteMacroCycles]).then(() => {
                this.changesGuard.unregisterChanges();
                resolve(true);
            }, (err) => {
                let message = this.translater.instant('Error_unknown');
                if (err instanceof ApiError) {
                    message = err.title;
                }

                this.toaster.open(message, '', {duration: 5000});
                reject(err);
            });
        });
    }

    public addPhaseEvent(week: Week) {
        this.phaseDialog = this.dialog.open(AnnualPlanDialogFormPhaseComponent, {
            data: {
                organization: this.organization,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                week,
                annualPlanPhases: this.annualPlanPhases,
                dialogTitle: 'PhaseAdd',
            }
        });

        this.subscriptions.push(
            this.phaseDialog.afterClosed().subscribe((data:any) => {

                // add a phase to corresponding week
                if (data.annualPlanPhase && !data.toDelete) {

                    // ajoute un tag
                    data.annualPlanPhase.tag = this.utils.getUniqTag();

                    // ajoute aux phases
                    this.annualPlanPhases.push(data.annualPlanPhase);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public annualPlanPhaseClickedEvent(annualPlanPhase: AnnualPlanPhase) {
        this.phaseDialog = this.dialog.open(AnnualPlanDialogFormPhaseComponent, {
            data: {
                organization: this.organization,
                annualPlanPhase,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                week: this.clickedWeek,
                annualPlanPhases: this.annualPlanPhases,
                dialogTitle: 'PhaseEdit',
            }
        });

        this.subscriptions.push(
            this.phaseDialog.afterClosed().subscribe((data:any) => {

                if (data.toDelete && data.annualPlanPhase) {

                    // liste des phases existantes à supprimer
                    this.annualPlanPhasesToDelete.push(annualPlanPhase.id!);

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanPhases.findIndex((e) => e.tag === data.annualPlanPhase.tag);
                    this.annualPlanPhases.splice(index, 1);
                    // this.arrayUtils.removeFromArrayByReference(this.annualPlanPhases, annualPlanPhase);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }

                // this is an update
                if (!data.toDelete && data.annualPlanPhase) {

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanPhases.findIndex((e) => e.tag === data.annualPlanPhase.tag);
                    this.annualPlanPhases[index] = data.annualPlanPhase;

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public addMacroCycleEvent(week: Week) {
        this.macroCycleDialog = this.dialog.open(AnnualPlanDialogFormMacrocycleComponent, {
            data: {
                organization: this.organization,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                week,
                dialogTitle: 'MacroCycleAdd',
                annualPlanMacroCycles: this.annualPlanMacroCycles,
            }
        });

        this.subscriptions.push(
            this.macroCycleDialog.afterClosed().subscribe((data:any) => {

                // add a phase to corresponding week
                if (data.annualPlanMacroCycle && !data.toDelete) {

                    // ajoute un tag
                    data.annualPlanMacroCycle.tag = this.utils.getUniqTag();

                    // ajoute aux cycles
                    this.annualPlanMacroCycles.push(data.annualPlanMacroCycle);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public annualPlanMacroCycleClickedEvent(annualPlanMacroCycle: AnnualPlanMacroCycle) {
        this.macroCycleDialog = this.dialog.open(AnnualPlanDialogFormMacrocycleComponent, {
            data: {
                organization: this.organization,
                annualPlanMacroCycle,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                week: this.clickedWeek,
                annualPlanMacroCycles: this.annualPlanMacroCycles,
                dialogTitle: 'MacroCycleEdit',
            }
        });

        this.subscriptions.push(
            this.macroCycleDialog.afterClosed().subscribe((data:any) => {

                // c'est une suppression
                if (data.toDelete && data.annualPlanMacroCycle) {

                    // liste des phases existantes à supprimer
                    this.annualPlanMacroCyclesToDelete.push(annualPlanMacroCycle.id!);

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanMacroCycles.findIndex((e) => e.tag === data.annualPlanMacroCycle.tag);
                    this.annualPlanMacroCycles.splice(index, 1);
                    // this.arrayUtils.removeFromArrayByReference(this.annualPlanMacroCycles, annualPlanMacroCycle);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }

                // this is an update
                if (!data.toDelete && data.annualPlanMacroCycle) {

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanMacroCycles.findIndex((e) => e.tag === data.annualPlanMacroCycle.tag);
                    this.annualPlanMacroCycles[index] = data.annualPlanMacroCycle;

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public attributeEvent() {
        this.phaseDialog = this.dialog.open(AnnualPlanDialogFormAttributeComponent, {
            data: {
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                organization: this.organization,
                dialogTitle: 'AttributePlan',
            }
        });
        this.subscriptions.push(
            this.phaseDialog.afterClosed().subscribe((data:any) => {
                if (data) {
                    this.toaster.open(this.translator.instant('AnnualPlan_Exported'), '', {duration: 5000});
                }
            })
        );
    }

    public switchAnnualPlan(annualPlan:any) {
        const currentPath = this.router.url;
        let url: string | null = null;

        if (currentPath.includes('plans-elitment')) {
            url = this.organization!.code + '/libraries/' + this.library.id + '/plans-elitment/' + annualPlan.id;
        } else if (currentPath.includes('plans-super-coach')) {
            url = this.organization!.code + '/libraries/' + this.library.id + '/plans-super-coach/' + annualPlan.id;
        } else if (currentPath.includes('plans/personal')) {
            url = this.organization!.code + '/libraries/' + this.library.id + '/plans/personal/' + annualPlan.id;
        } else {
            // Default to personal plans
            url = this.organization!.code + '/libraries/' + this.library.id + '/plans/personal/' + annualPlan.id;
        }

        this.router.navigate([url]);
    }

    private loadData() {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //{ organization: Organization; library: Library; annualPlanData: AnnualPlanData; context: number }
                this.organization = data.organization;
                this.library = data.library ? data.library : null;
                this._displayContext = data.context;
                this.annualPlan = data.annualPlanData['plan'];

                this.annualPlanRights.evaluateScreenRights({
                    rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
                });

              this.annualPlanRights.evaluateItemRight(this.annualPlan.rights);

                this.annualPlanForm.patchValue(data.annualPlanData['plan']);
                this.annualPlan = data.annualPlanData['plan'];
                this.weeks = data.annualPlanData['weeks'];
                this.annualPlanPhases = data.annualPlanData['phases'];
                this.annualPlanMacroCycles = data.annualPlanData['macroCycles'];

                // attribue des tags
                for (let i = 0; i < this.annualPlanPhases.length; i++) {
                    // @ts-ignore
                    this.annualPlanPhases[i].tag = this.utils.getUniqTag();
                }
                for (let i = 0; i < this.annualPlanMacroCycles.length; i++) {
                    // @ts-ignore
                    this.annualPlanMacroCycles[i].tag = this.utils.getUniqTag();
                }
            })
        );

        this.subscriptions.push(
            this.exerciseProvider.getExerciseCategories(this.organization).subscribe((categories) => {
                this.exerciseCategories = categories;
            })
        );

        this.subscriptions.push(
            this.phaseProvider.findAll(this.organization).subscribe((phases) => {
                this.phases = phases;
            })
        );

        this.subscriptions.push(
            this.route.paramMap.subscribe((map:any) => {
                this.isEditMode = 'edit' === map['params']['edit'];
            })
        );

        this.subscriptions.push(
            this.annualPlanService.findAllByOrganizationWithoutPlansInMap(this.organization, [this.annualPlan]).subscribe((annualPlans) => {
                this.titleSwitcherItems = annualPlans.map((annualPlan) => ({
                    title: annualPlan.title!,
                    icon: null,
                    url: null,
                    onClick: () => this.switchAnnualPlan(annualPlan)
                }));
            })
        );
    }

    private createPageTitle() {
        this.pageTitle = this.annualPlan.title ??'';
    }

    private createBreadcrumb() {
        // Detect the current route context
        const currentPath = this.route.snapshot.url.map(segment => segment.path).join('/');
        const libraryId = this.annualPlan.libraryId || this.library?.id;
        let listUrl: string;
        let detailUrl: string;
        let editUrl: string;
        let categoryTitle: string;

        if (currentPath.includes('plans-elitment')) {
            // Elitment plans context
            categoryTitle = this.translator.instant('Elitment_annual_plans_title');
            this._title.setTitle(this.pageTitle + ' | ' + categoryTitle + ' | ' + this.conf.platformName);
            listUrl = this.organization!.code + '/libraries/' + libraryId + '/plans-elitment';
            detailUrl = this.organization!.code + '/libraries/' + libraryId + '/plans-elitment/' + this.annualPlan.id;
            editUrl = this.organization!.code + '/libraries/' + libraryId + '/plans-elitment/' + this.annualPlan.id + '/edit';
        } else if (currentPath.includes('plans-super-coach')) {
            // Super Coach plans context
            categoryTitle = this.translator.instant('Super_coaches_annual_plans_title');
            this._title.setTitle(this.pageTitle + ' | ' + categoryTitle + ' | ' + this.conf.platformName);
            listUrl = this.organization!.code + '/libraries/' + libraryId + '/plans-super-coach';
            detailUrl = this.organization!.code + '/libraries/' + libraryId + '/plans-super-coach/' + this.annualPlan.id;
            editUrl = this.organization!.code + '/libraries/' + libraryId + '/plans-super-coach/' + this.annualPlan.id + '/edit';
        } else {
            // Personal plans context (default for old routes)
            categoryTitle = this.translator.instant('Personal_annual_plans_title');
            this._title.setTitle(this.pageTitle + ' | ' + categoryTitle + ' | ' + this.conf.platformName);
            listUrl = this.organization!.code + '/libraries/' + libraryId + '/plans/personal';
            detailUrl = this.organization!.code + '/libraries/' + libraryId + '/plans/personal/' + this.annualPlan.id;
            editUrl = this.organization!.code + '/libraries/' + libraryId + '/plans/personal/' + this.annualPlan.id + '/edit';
        }

        const crumbs: Crumb[] = [{
            shortTitle: categoryTitle,
            title: categoryTitle,
            url: listUrl
        }, {
            shortTitle: this.annualPlan.title ?? '',
            title: this.annualPlan.title ?? '',
            url: detailUrl
        }];

        if (this.isEditMode) {
            crumbs.push({
                shortTitle: 'Edition',
                title: 'Edition',
                url: editUrl
            });
        }

        this.breadcrumbProvider.setDefaultCrumbs(crumbs);
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 404) {
            this.is404 = true;
        } else if (error.status === 401) {
            this.is401 = true;
        }
    }
}
